import { hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { BeniBreakdown } from 'lumen/models';
import BeniPaceApiResponse from 'lumen/models/benchmark-insight/pace-api-response';

export default class BeniDataApiResponse extends BeniPaceApiResponse {
  // @ts-expect-error: Class inheritance
  [Type] = 'benchmark-insight/data-api-response' as const;

  @hasMany('benchmark-insight/breakdown', { async: false, inverse: null })
  declare channel: BeniBreakdown[];

  @hasMany('benchmark-insight/breakdown', { async: false, inverse: null })
  declare los: BeniBreakdown[];

  @hasMany('benchmark-insight/breakdown', { async: false, inverse: null })
  declare segment: BeniBreakdown[];

  @hasMany('benchmark-insight/breakdown', { async: false, inverse: null })
  declare week: BeniBreakdown[];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get filteredChannelSegmentations() {
    const filteredSegmentations = this.filterSegmentationsByComparisonSetType(
      this.channel,
    );

    return filteredSegmentations;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get filteredLosSegmentations() {
    const filteredSegmentations = this.filterSegmentationsByComparisonSetType(
      this.los,
    );
    return filteredSegmentations;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get filteredSegmentSegmentations() {
    const filteredSegmentations = this.filterSegmentationsByComparisonSetType(
      this.segment,
    );

    return filteredSegmentations;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get filteredWeekSegmentations() {
    const filteredSegmentations = this.filterSegmentationsByComparisonSetType(
      this.week,
    );

    return filteredSegmentations;
  }
}
